export default {
    // modules
    actions: '',
    assets: 'PhTreeView',
    companies: 'mdi-office-building',
    contacts: 'mdi-contacts-outline',
    dashboard: 'PhLayout',
    documents: 'mdi-file-document',
    employees: 'PhAddressBook',
    fields: 'mdi-format-letter-matches',
    home: 'mdi-home',
    locations: 'mdi-map-marker',
    notes: 'mdi-note',
    people: 'mdi-human-male-female',
    permissions: 'mdi-security',
    plans: 'PhCalendarBlank',
    projects: 'PhBriefcase',
    profile: 'mdi-account',
    roles: 'PhUserSwitch',
    reports: 'PhFileText',
    scripttemplates: 'mdi-file-document-edit',
    //NO STABU FOR INBEDRIJFSTELLERS
    // stabu: 'PhBooks',
    settings: 'PhSlidersHorizontal',
    tags: 'mdi-tag',
    tickets: 'PhLifebuoy',
    tokens: 'mdi-account-key',
    translations: 'mdi-translate',
    triggers: '',
    users: 'mdi-account',
    workflows: 'mdi-transit-connection-variant',
}